/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataStructureGraphIcon16Solid = forwardRef('DataStructureGraphIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1 3.75A2.75 2.75 0 0 1 3.75 1h5.5a2.75 2.75 0 1 1 0 5.5H8.202l2 3h2.048a2.75 2.75 0 1 1 0 5.5h-5.5a2.75 2.75 0 1 1 0-5.5h1.048l-2-3H3.75A2.75 2.75 0 0 1 1 3.75Z" })));
});
